// Please, do not create analytics events here
// Use the protobuf event repository instead
// packages/core/src/protos/events/so5/web/events.ts
// packages/core/src/protos/events/so5/shared/events.ts
// We will slowly migrate all self-defined events to the protobuf repository

import { Sport, Sport as SportType } from '__generated__/globalTypes';

export const socialShareEventName = {
  SHARE_CARD: 'Share Card',
  SHARE_LINEUP: 'Share Lineup',
  SHARE_USER_GROUP: 'Share User Group',
  SHARE_SQUAD: 'Share Squad',
  SHARE_COLLECTION: 'Share Collection',
  SHARE_REFERRAL: 'Share Referral Link',
  SHARE_AUCTION_WON: 'Share Auction Won',
  SHARE_MANAGER_PROFILE: 'Share Manager Profile',
  SHARE_GALLERY: 'Share Gallery',
  SHARE_BLOG_POST: 'Share Blog Post',
  SHARE_DUO_MISSION: 'Share Duo Mission',
  SHARE_WATCHLIST: 'Share Watchlist',
} as const;

export type SocialShareEventName =
  (typeof socialShareEventName)[keyof typeof socialShareEventName];

export const socialShareEventContext = {
  COMPETITION_DETAILS: 'Competition Details',
  LEADERBOARD: 'Leaderboard',
  MY_TEAMS: 'My Teams',
  LIVE_PRO: 'Live Pro',
  LINEUP_BUTTONS: 'Lineup buttons',
  COLLECTION: 'Collection Page',
  USER_GROUP_DETAILS: 'User Group Details',
  USER_GROUP_CONGRATS: 'User Group Congratulations Dialog',
  USER_GROUP_INVITE_FRIENDS: 'User Group Invite Friends',
  REFERRAL_PROGRAM: 'referral_program',
  HERO_HOMEPAGE: 'hero_homepage',
  ONBOARDING: 'onboarding',
  SQUAD: 'squad',
  HOME_DASHBOARD: 'Home Dashboard',
  AUCTION_WON: 'Auction Won Dialog',
  CARD_PAGE: 'Card Page',
  MANAGER_PROFILE: 'Manager Profile',
  BLOG: 'Blog',
  MISSIONS_PAGE: 'Missions Page',
  WATCHLIST_PAGE: 'Watchlist Page',
} as const;

const FOOTBALL = 'football';

export type SocialShareEventContext =
  (typeof socialShareEventContext)[keyof typeof socialShareEventContext];

export const shareByCopyLinkEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'copy_link',
    context,
  },
});

export const shareByImageEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'image',
    context,
  },
});

export const shareOnTwitterEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'twitter',
    context,
  },
});

export const shareOnFacebookEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'facebook',
    context,
  },
});

export const shareWithShareSheetEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'share_sheet',
    context,
  },
});

export const ANALYTICS_TAGS = {
  [Sport.NBA]: 'NBA',
  [Sport.BASEBALL]: 'Baseball',
  [Sport.FOOTBALL]: 'Football',
} as const;
